import { createRoot } from "react-dom/client";

import Widget, { DataPropsSchema } from "./Widget";

(function ready() {
    if (window.location.search.includes("debug")) {
        debugger;
    }
    if (document.readyState !== "loading") {
        setInterval(onReady, 500);
    } else {
        document.addEventListener("DOMContentLoaded", onReady);
    }
})();

function onReady() {
    const initClass = "--processed";
    const roots = Array.from(
        document.querySelectorAll(`.hsl-ffr:not(.${initClass})`),
    );
    const script = document.querySelector("#hsl-ffs") as HTMLScriptElement;
    if (!roots.length) {
        console.info("No uninitialised fund-finder widgets found");
        return;
    }
    if (!script) {
        console.log(
            "Unable to determine source domain, please add the id `hsl-ffs` to the HSL widget script",
        );
        return;
    }
    const getDataset = getDataAttributes("data-hsl-");

    roots.forEach((root) => {
        const props = DataPropsSchema.parse(getDataset(root));
        root.classList.add(initClass);
        createRoot(root).render(
            <Widget
                dataProps={props}
                stylesheet={script.src.replace(".js", ".css")}
            />,
        );
    });
}

function getDataAttributes(prefix: string) {
    return (element: Element): Record<string, string> => {
        const result = Array.from(element.attributes)
            .filter((attr) => attr.name.startsWith(prefix))
            .reduce(
                (attrs, attr) => {
                    attrs[toCamelCase(attr.name.substring(prefix.length))] =
                        attr.value;
                    return attrs;
                },
                {} as Record<string, string>,
            );
        return result;
    };
}

function toCamelCase(str: string) {
    return str
        .toLowerCase()
        .split(/[\s-_]+/) // Split the string by space, underscore, or hyphen
        .map((word, index) => {
            // If it's the first word, return it as is. Otherwise, capitalize the first letter.
            return index === 0
                ? word
                : word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(""); // Join all the words together
}
